import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

const settingsSectionComponentStyle1 = css`
  background: ${theme.colors.white};
  padding: ${theme.spacing(3)};
  border-radius: ${theme.borderRadius.medium};
  box-shadow: ${theme.shadows.light};
`;

export const SettingsSectionStyles = {
  settingsSectionComponentStyle1,
};
